import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {EmbedEvent, SearchEmbed} from "@thoughtspot/visual-embed-sdk";
import {environment} from "@environments/environment";
import {AuthService} from "@app/_services/auth.service";
import {ThoughtspotService} from "@app/_services/thoughtspot.service";
import {IdentityUser} from "@app/_models/identityUser";
import {Subscription} from "rxjs";

@Component({
    selector: 'app-search',
    imports: [],
    templateUrl: './search.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './search.component.scss'
})
export class SearchComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild("liveboard") liveboard!: ElementRef;
    private userSubscription: Subscription;
    user: IdentityUser | null = null;

    constructor(private authService: AuthService, private thoughtspotService: ThoughtspotService) {
        this.userSubscription = this.authService.user().subscribe((user: IdentityUser | null) => this.user = user);
    }

    ngOnInit(): void {
        this.thoughtspotService.initEmbedSDK();
    }

    ngAfterViewInit(): void {
        this.renderSearch();
    }

    ngOnDestroy(): void {
        this.userSubscription.unsubscribe();
    }

    private renderSearch() {
        const embed = new SearchEmbed(this.liveboard.nativeElement, {
            frameParams: {},
            dataPanelV2: true,
            enableSearchAssist: true,
            visibleActions: environment.thoughtSpotConfig.searchPageActions,
        });

        embed.on(EmbedEvent.Pin, _ => {
            this.thoughtspotService.getLiveboards();
        }).render().then();
    }
}